import {
    CALCULATIONS_SERVICE_NAME,
    CONDITION_SERVICE_NAME,
    ConditionParameterServiceName
} from "../utils/names/serviceNames";
import {CALCULATIONS_SERVICE} from "./services/calculationsService";
import {CALCULATIONS_CONTROLLER} from "./controllers/calculationsController";
import {CALCULATIONS_GRID_COMPONENT} from "./components/calcaulations_grid/calculationsGridComponent";
import {CalculationsItemComponent} from "./components/calculations_item/calculationsItemComponent";
import {PERCENTAGE_PARAMETER_COMPONENT} from "./components/parameters/percentage-parameter/percentageParameter";
import {ConditionsList} from "./components/conditions_list/conditionsList";
import {EditPercentageParameter} from "./components/parameters-edit/percentage/EditPercentage";
import {ConditionService} from "./services/conditionService";
import {ConditionItemRateDate} from "./components/conditions/rate_date/ConditionItemRateDate";
import {ConditionItemSavings} from "./components/conditions/savings/ConditionItemSavings";
import {DollarValueParameter} from "./components/parameters/dollar-val-parameter/dollarValueParameter";
import {ConditionItemRate} from "./components/conditions/rate/ConditionItemRate";
import {ConditionParameter} from "./components/parameters/condition_parameter/conditionParameter";
import {EditDollarValue} from "./components/parameters-edit/dollar-value/EditDollarValue";
import {ConditionEquityExceeds} from "./components/conditions/equity/ConditionEquityExceeds";
import {EquityPercentage} from "./components/parameters/equity/equityPercentage";
import {EditEquity} from "./components/parameters-edit/equity/EditEquity";
import {ConditionParameterService} from "./services/ConditionParameterService";
import {ConditionEquityLessThen} from "./components/conditions/equity/ConditionEquityLessThen";
import {ConditionOriginalEquityExceeds} from "./components/conditions/equity/ConditionOriginalEquityExceeds";
import {ConditionOriginalEquityLessThen} from "./components/conditions/equity/ConditionOriginalEquityLessThen";
import {CalculationModuleConfiguration} from "./CalculationsModuleConfiguration";


CalculationModuleConfiguration
    .createNewModule()
    .controller('calculationsController', CALCULATIONS_CONTROLLER)
    .component('calculationGrid', CALCULATIONS_GRID_COMPONENT)
    .component('calculationItem', CalculationsItemComponent.instance)
    .component('conditionsList', ConditionsList.instance)
    .component('conditionItemRate', ConditionItemRate.instance())
    .component('conditionItemRateDate', ConditionItemRateDate.instance())
    .component('conditionItemSavings', ConditionItemSavings.instance())
    .component('conditionItemEquityGreater', ConditionEquityExceeds.instance())
    .component('condiitonItemOriginalEquityGreater', ConditionOriginalEquityExceeds.instance())
    .component('condiitonItemOriginalEquityLessThen', ConditionOriginalEquityLessThen.instance())
    .component('conditionItemEquityLower', ConditionEquityLessThen.instance())
    .component('conditionParameter', ConditionParameter.instance)
    .component('percentageParameter', PERCENTAGE_PARAMETER_COMPONENT)
    .component('dollarValueParameter', DollarValueParameter.instance)
    .component('equityPercentage', EquityPercentage.instance)
    .component('editDollarValue', EditDollarValue.instance())
    .component('editPercentageParameter', EditPercentageParameter.instance())
    .component('editEquityValue', EditEquity.instance())
    .service(ConditionParameterServiceName, ConditionParameterService.instance)
    .service(CONDITION_SERVICE_NAME, ConditionService.instance)
    .service(CALCULATIONS_SERVICE_NAME, CALCULATIONS_SERVICE);